"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TaxonomyResponses;
(function (TaxonomyResponses) {
    var ViewTaxonomyGroupResponse = /** @class */ (function () {
        function ViewTaxonomyGroupResponse(
        /**
         * Taxonomy group
         */
        taxonomy, 
        /**
         * Debug information
         */
        debug) {
            this.taxonomy = taxonomy;
            this.debug = debug;
        }
        return ViewTaxonomyGroupResponse;
    }());
    TaxonomyResponses.ViewTaxonomyGroupResponse = ViewTaxonomyGroupResponse;
    var ListTaxonomyGroupsResponse = /** @class */ (function () {
        function ListTaxonomyGroupsResponse(
        /**
         * Taxonomies
         */
        taxonomies, 
        /**
         * Pagination
         */
        pagination, 
        /**
         * Debug information
         */
        debug) {
            this.taxonomies = taxonomies;
            this.pagination = pagination;
            this.debug = debug;
        }
        return ListTaxonomyGroupsResponse;
    }());
    TaxonomyResponses.ListTaxonomyGroupsResponse = ListTaxonomyGroupsResponse;
})(TaxonomyResponses = exports.TaxonomyResponses || (exports.TaxonomyResponses = {}));
//# sourceMappingURL=responses.js.map


// WEBPACK FOOTER //
// ./node_modules/kentico-cloud-delivery/_commonjs/models/taxonomy/responses.js